import styled from "styled-components";

export const ModalHeader = styled.h2`
  font-family: "Inter", sans-serif;
  color: ${(p) => p.theme.textPrimary};
`;

export const Separator = styled.hr`
  width: calc(100% + 32px);
  position: relative;
  left: -16px;
  margin: 0.5rem 0;
  border-color: #cdcdcd;
  opacity: 0.5;
`;
